import ConfirmationPopup from './ConfirmationPopup';

export default ConfirmationPopup;
